
const OtpInput = (props) => {
    const {
        //Set the default size to 6 characters
        size = 6,
        //Default validation is digits
        validationPattern = /[0-9]{1}/,
        value,
        onChange,
        ...restProps
    } = props;

    const handleKeyUp = (evt) => {
        const current = evt.currentTarget;

        if (evt.key === "ArrowLeft" || evt.key === "Backspace") {
            const prev = current.previousElementSibling;
            prev?.focus();
            prev?.setSelectionRange(0, 1);
            return;
        }

        if (evt.key === "ArrowRight") {
            const prev = current.nextSibling;
            prev?.focus();
            prev?.setSelectionRange(0, 1);
            return;
        }
    };


    const handleInputChange = (evt, index) => {
        const elem = evt.target;
        const val = evt.target.value;

        // check if the value is valid
        if (!validationPattern.test(val) && val !== "") return;

        // change the value of the upper state using onChange
        const valueArr = value.split("");
        valueArr[index] = val;
        const newVal = valueArr.join("").slice(0, 6);
        onChange(newVal);

        //focus the next element if there's a value
        if (val) {
            const next = elem.nextElementSibling;
            next?.focus();
        }
    };

    // Create an array based on the size.
    const arr = new Array(size).fill("-");

    return (
        <div className="flex gap-2">
            {/* Map through the array and render input components */}
            {arr.map((_, index) => {
                return (
                    <input
                        aria-label="otp digit"
                        key={index}
                        {...restProps}
                        type="text"
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        className="flex-1 w-1 px-3 py-6 rounded-md text-center bg-gray-200"
                        pattern={validationPattern.source}
                        maxLength={6}
                        value={value.at(index) ?? ""}
                        onChange={(evt) => handleInputChange(evt, index)}
                        onKeyUp={handleKeyUp}
                    />
                );
            })}
        </div>
    );
}

export default OtpInput;
